export enum AffiliateStatus {
  New,
  Active,
  Banned,
}
